import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URL, PRICE, ANCHOR_PRICE, TOTAL_VALUE, SAVINGS } from '../lib/config';
const volumes = ['Volume 0 — The Run of Show', 'Volume 1 — Getting Ready', 'Volume 2 — First Look & Couple Prep', 'Volume 3 — The Ceremony', 'Volume 4 — Family & Group Formals ⭐', 'Volume 5 — Couple Portraits & Golden Hour', 'Volume 6 — The Reception'];
const bonuses = ['Bonus 1 — Client Clarity Questionnaire', 'Bonus 2 — Wedding Week Email Pack', 'Bonus 3 — No-Panic Gear Checklist', 'Bonus 4 — Venue Walkthrough Note Sheet', 'Bonus 5 — Calm Authority Phrase Book'];
export function Pricing() {
  return <section id="pricing" className="w-full bg-ivory py-16 sm:py-24" data-id="element-200" data-mp="20v7qz1hhm1bx">
      <div className="mx-auto max-w-3xl px-5" data-id="element-201" data-mp="3h638aa24esoz">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-202" data-mp="3c8a4tos7ccse">
          Get the whole day scripted today
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-203" data-mp="3vyf54m78ypz7" />

        <div className="mt-12 border border-gold bg-white shadow-card" data-id="element-204" data-mp="4svvrpspr2sv">
          <div className="border-b border-gold-soft/70 bg-gold-tint px-7 py-8 text-center" data-id="element-205" data-mp="4uyv50fra8a9">
            <h3 className="font-serif text-2xl sm:text-3xl text-ink" data-id="element-206" data-mp="9q5rfn6p4ap5">
              Direct the Day™ — Complete Edition
            </h3>
            <p className="mt-3 text-sm text-ink-soft" data-id="element-207" data-mp="3d9h7hecqc9zo">
              Everything you need to run the entire wedding day — from getting ready to the
              send-off
            </p>
          </div>

          <div className="grid gap-x-10 gap-y-3 px-7 py-9 sm:grid-cols-2" data-id="element-208" data-mp="3n6ljilcv2p2r">
            {volumes.map(item => <p key={item} className="flex items-start gap-3 text-[15px] text-ink" data-id="element-209" data-mp="3rywwaospa5cq">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-210" data-mp="2uizf5avt7geu" />
                {item}
              </p>)}
            {bonuses.map(item => <p key={item} className="flex items-start gap-3 text-[15px] text-ink-soft" data-id="element-211" data-mp="2rf1stxn5xa57">
                <GiftIcon className="mt-1 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-212" data-mp="2mh8nf6took5z" />
                {item}
              </p>)}
          </div>

          <div className="border-t border-gold-soft/70 px-7 py-9 text-center" data-id="element-213" data-mp="2w9o50312j6qc">
            <p className="text-[11px] uppercase tracking-[0.24em] text-ink-muted" data-id="element-214" data-mp="28iipjoz1iggk">
              Total value: {TOTAL_VALUE}
            </p>
            <p className="mt-4 text-sm text-ink-muted" data-id="element-215" data-mp="2ig6nsovuu63h">
              Regular price: <s data-id="element-216" data-mp="2ihhqsmhh79tj">{ANCHOR_PRICE} USD</s>
            </p>
            <p className="mt-2 flex items-end justify-center gap-2" data-id="element-217" data-mp="2dgtzs0t8yszb">
              <span className="font-serif text-6xl leading-none text-ink" data-id="element-218" data-mp="3tvbqvtzwe6nm">{PRICE}</span>
              <span className="pb-2 text-xs uppercase tracking-[0.2em] text-ink-muted" data-id="element-219" data-mp="3tx6c79f300s8">
                USD
              </span>
            </p>
            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[11px] uppercase tracking-[0.16em]" data-id="element-220" data-mp="a42dnwg2onc">
              <li className="bg-ink px-3 py-1.5 text-gold" data-id="element-221" data-mp="5arte9kob5hk">Save {SAVINGS}</li>
              <li className="border border-gold-soft px-3 py-1.5 text-ink-soft" data-id="element-222" data-mp="3ngelvqj26y3e">
                One-time payment
              </li>
              <li className="border border-gold-soft px-3 py-1.5 text-ink-soft" data-id="element-223" data-mp="3rirfxhog17kc">
                Lifetime access
              </li>
            </ul>

            <p className="mt-8 text-xs italic text-ink-muted" data-id="element-224" data-mp="o07xt7zhbi39">
              You will be charged in your local currency.
            </p>

            <div className="mt-4" data-id="element-225" data-mp="a8b8tct3xob3">
              <CtaButton href={CHECKOUT_URL} className="w-full sm:w-auto" data-id="element-226" data-mp="e9wsbh05d0u9">
                Yes, I want Direct the Day
              </CtaButton>
            </div>

            <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-227" data-mp="11yg1rzuxnjnx">
              <li className="inline-flex items-center gap-2" data-id="element-228" data-mp="3f81sqwt9l6ov">
                <LockIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-229" data-mp="3f5fnj3tuj39t" />
                Secure checkout
              </li>
              <li className="inline-flex items-center gap-2" data-id="element-230" data-mp="358t1wctp486q">
                <ZapIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-231" data-mp="35bfa8eoeurq0" />
                Instant download
              </li>
              <li className="inline-flex items-center gap-2" data-id="element-232" data-mp="1t5fdkt3wvax">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-233" data-mp="1ugjjlqgs52k" />
                30-day guarantee
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}